/*
  Eatalia - openingsstatus en "vandaag" bij de openingstijden.
  Rekent altijd in Nederlandse tijd, ook als de bezoeker in het buitenland zit.
  Tijden in Shopify noteer je als 12:00-22:00 (een punt of een lang streepje mag ook).
  Een lege dag betekent: gesloten.
*/
(function () {
  if (window.__eataliaStatus) return;
  window.__eataliaStatus = true;

  var DAGEN = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];

  function nuInNederland() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    var dag = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(map.weekday) + 1;
    return { dag: dag, minuten: (parseInt(map.hour, 10) % 24) * 60 + parseInt(map.minute, 10) };
  }

  function leesTijden(tekst) {
    if (!tekst) return null;
    var m = String(tekst).match(/(\d{1,2})[:.](\d{2})\s*[-\u2013\u2014]\s*(\d{1,2})[:.](\d{2})/);
    if (!m) return null;
    var open = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    var dicht = parseInt(m[3], 10) * 60 + parseInt(m[4], 10);
    if (dicht <= open) dicht += 24 * 60;
    return { open: open, dicht: dicht, van: m[1].padStart(2, '0') + ':' + m[2], tot: m[3].padStart(2, '0') + ':' + m[4] };
  }

  function statusTekst(hours, nu) {
    var vandaag = leesTijden(hours[nu.dag]);
    if (vandaag && nu.minuten >= vandaag.open && nu.minuten < vandaag.dicht) {
      return { open: true, tekst: 'nu open tot ' + vandaag.tot };
    }
    if (vandaag && nu.minuten < vandaag.open) {
      return { open: false, tekst: 'vandaag open vanaf ' + vandaag.van };
    }
    for (var i = 1; i <= 7; i++) {
      var d = ((nu.dag - 1 + i) % 7) + 1;
      var t = leesTijden(hours[d]);
      if (t) {
        return { open: false, tekst: (i === 1 ? 'morgen' : DAGEN[d - 1]) + ' open vanaf ' + t.van };
      }
    }
    return { open: false, tekst: 'gesloten' };
  }

  function update(scope) {
    var nu = nuInNederland();
    (scope || document).querySelectorAll('[data-eat-status]').forEach(function (el) {
      var hours;
      try { hours = JSON.parse(el.getAttribute('data-hours') || '{}'); } catch (e) { return; }
      var s = statusTekst(hours, nu);
      var text = el.querySelector('.eat-status__text');
      if (text) text.textContent = (el.getAttribute('data-naam') || '') + ' \u00b7 ' + s.tekst;
      el.classList.toggle('is-open', s.open);
    });
    (scope || document).querySelectorAll('[data-eat-dag="' + nu.dag + '"]').forEach(function (row) {
      row.classList.add('is-today');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update(); });
  } else {
    update();
  }
  setInterval(update, 60 * 1000);
  document.addEventListener('shopify:section:load', function (e) { update(e.target); });
})();